if (!customElements.get('sanalio-pack-costs')) {
  customElements.define('sanalio-pack-costs', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      this.input = this.querySelector('[data-daily-grams]');
      this.strings = JSON.parse(this.querySelector('[data-cost-strings]').textContent);
      this.cards = Array.from(this.querySelectorAll('.variant-card')).map(el => ({
        el, grams: Number(el.dataset.netGrams), price: Number(el.dataset.variantPrice),
        plans: JSON.parse(el.dataset.planPrices), unit: el.querySelector('.variant-card__unit').textContent
      }));
      this.money = new Intl.NumberFormat(this.dataset.locale || 'fr', {
        style: 'currency', currency: this.dataset.currency || 'EUR'
      });
      document.addEventListener('sanalio:purchase-change', event => {
        if (event.detail.section === this.dataset.section) this.render(event.detail.planId);
      }, { signal: this.abort.signal });
      this.input.addEventListener('input', () => this.render(this.planId), { signal: this.abort.signal });
      this.querySelector('[data-cost-stage]')?.addEventListener('change', event => {
        this.input.value = event.target.value;
        this.render(this.planId);
      }, { signal: this.abort.signal });
      const widget = Array.from(document.querySelectorAll('sanalio-selling-plans'))
        .find(el => el.dataset.section === this.dataset.section);
      this.render(widget?.querySelector('[name="selling_plan"]')?.value || '', false);
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.abort = null;
    }
    render(planId = '', announce = true) {
      this.planId = planId;
      const grams = Number(this.input.value);
      const valid = this.input.value !== '' && this.input.validity.valid && grams > 0;
      this.cards.forEach(card => {
        const allocation = card.plans.find(plan => plan.id === planId);
        const available = !planId || Boolean(allocation);
        const cents = planId ? allocation?.price : card.price;
        const money = value => this.money.format(Math.round(value) / 100);
        card.el.querySelector('.variant-card__price').textContent = available ? money(cents) : '—';
        card.el.querySelector('.variant-card__unit').textContent = available ? card.unit : this.strings.unavailable;
        const kg = card.el.querySelector('.variant-card__kg');
        if (kg) kg.textContent = available && card.grams > 0 ? money(cents * 1000 / card.grams) + '/kg' : '—';
        const daily = card.el.querySelector('[data-daily-cost]');
        if (daily) {
          daily.hidden = !available || !valid;
          if (available && valid) daily.querySelector('[data-day-price]').textContent = money(cents * grams / card.grams);
        }
      });
      this.querySelector('[data-cost-mode]').textContent = planId ? this.strings.subscription : this.strings.once;
      if (announce) this.querySelector('[data-cost-status]').textContent = valid ? this.strings.updated.replace('{{ grams }}', grams) : '';
    }
  });
}
